import { render } from "./trade-summary-report.vue?vue&type=template&id=120680ed&scoped=true"
import script from "./trade-summary-report.vue?vue&type=script&lang=js"
export * from "./trade-summary-report.vue?vue&type=script&lang=js"

import "./trade-summary-report.vue?vue&type=style&index=0&id=120680ed&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-120680ed"]])

export default __exports__